import { OffboardingSource, OffboardReason } from "@/model/Prescription"
import { formatDateTime } from "@/utils/date-utils"
import { Instant } from "@js-joda/core"
import { offboardReasonLabels } from "./offboardReasonLabels"

type OffboardingSummaryProps = {
  reason: OffboardReason
  note?: string
  offboardedBy: string
  offboardedAt: Instant
  source: OffboardingSource
}

const sourceLabels: Record<OffboardingSource, string> = {
  clinician: "Clinician",
  support: "Support",
}

const OffboardingSummary = ({
  reason,
  note,
  offboardedBy,
  offboardedAt,
  source,
}: OffboardingSummaryProps) => {
  return (
    <div className="mb-4 flex items-start gap-3 rounded-lg border border-primary/10 bg-primary/5 px-4 py-3">
      <div className="flex flex-col gap-0.5">
        <p className="text-sm font-semibold text-primary">
          {offboardReasonLabels[reason]}
        </p>
        <div className="flex items-center gap-2 text-xs text-primary/60">
          <span>Closed by {offboardedBy}</span>
          <span>·</span>
          <span>via {sourceLabels[source]} Portal</span>
          <span>·</span>
          <span>{formatDateTime(offboardedAt, "MMM dd, yyyy")}</span>
        </div>
        {note && <p className="text-xs italic text-primary/50">Note: {note}</p>}
      </div>
    </div>
  )
}

export default OffboardingSummary
